export enum ALTERNATE_TRIGGERS {
  TRIGGER_EVENT = 'event',
  TRIGGER_TIME = 'time',
  TRIGGER_DURATION = 'duration',
  TRIGGER_DONE = 'done',
}
